import { templateSlugs } from "../constants";

const formatDateTime = (dateString, timeZone, tzAbbr) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  }).formatToParts(date);

  const get = (type) => parts.find(p => p.type === type)?.value;

  const month = get("month");
  const day = get("day");
  const hour = get("hour");
  const minute = get("minute");
  const dayPeriod = get("dayPeriod");

  return `${month} ${day} at ${hour}:${minute} ${dayPeriod} ${tzAbbr || ""}`.trim();
};

const getInviteTimeLabel = ({ outStandingJob, timezone, tzAbbr, loggedInUserId }) => {
  if (!outStandingJob) return "";
  const scheduled = outStandingJob?.fire_after;
  const sent = outStandingJob?.updated_at;
  const createdBy = outStandingJob?.created_by;
  const { first_name, last_name, person_uuid } = createdBy;

  let timeLabel = ""

  if (scheduled) {
    timeLabel = `Scheduled for ${formatDateTime(scheduled, timezone, tzAbbr)}`;
  }

  if (sent) {
    timeLabel = `Sent on ${formatDateTime(sent, timezone, tzAbbr)}`;
  }

  if (person_uuid !== loggedInUserId) {
    timeLabel += ` by ${first_name} ${last_name}`
  }

  return timeLabel;
};

const isScheduled = (fireAfter, timeZone) => {
  if (!fireAfter) return false;

  const now = new Date();

  const nowInTZ = new Date(
    new Intl.DateTimeFormat("en-US", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    }).format(now)
  );

  const fireDate = new Date(fireAfter);

  return fireDate > nowInTZ;
};

const resolveTemplateSlug = (actionType, status) => {
  if (actionType === "approved" && status === "waitlist_offered") {
    return templateSlugs.backupAccepted;
  }

  if (actionType === "denied" && status === "waitlist_offered") {
    return templateSlugs.backupRejected;
  }

  if (actionType === "waitlist_offered") {
    return templateSlugs.backup;
  }

  if (actionType === "approved") return templateSlugs.accepted;
  if (actionType === "denied" || actionType === "rejected") return templateSlugs.rejected;

  return templateSlugs.invite;
};

const getTemplateBtnName = (actionType, status) => {
  if (actionType === "approved" && status === "waitlist_offered") {
    return "Send";
  }

  if (actionType === "denied" && status === "waitlist_offered") {
    return "Send";
  }

  if (actionType === "waitlist_offered") {
    return "Send Backup Invite";
  }

  if (actionType === "approved") return "Send";
  if (actionType === "denied" || actionType === "rejected") return "Send";
  if (actionType === "offered") return "Resend Invite";

  return "Send Invite";
};

export {
  getInviteTimeLabel,
  formatDateTime,
  isScheduled,
  resolveTemplateSlug,
  getTemplateBtnName
}